import { AxiosResponse } from 'axios';
import onlineApi from 'v3/services/online/config';
import {
  ICancelOrderRequest,
  IContractingCancellationRequest,
  IGetContractingListInAppParams,
} from 'v3/services/online/interfaces/request';
import {
  ICancelVtexOrderResponse,
  IContractingCancellationResponse,
  IGetContractingListInAppResponse,
  IGetContractingOnlineStateResponse,
  IGetPaymentDetailsResponse,
  IGetVtexOrderResponse,
} from 'v3/services/online/interfaces/response';

export const getContractingListInApp = (
  params: IGetContractingListInAppParams,
): Promise<AxiosResponse<IGetContractingListInAppResponse>> => {
  return onlineApi.get(`/contracting/list/in-app`, { params });
};

export const getContractingState = (
  contractingKey: string,
): Promise<AxiosResponse<IGetContractingOnlineStateResponse>> => {
  return onlineApi.get(`/contracting/get-state/${contractingKey}`);
};

export const getPaymentDetails = (paymentId: string): Promise<AxiosResponse<IGetPaymentDetailsResponse>> => {
  return onlineApi.get(`/financing-in-app/get-payment-details/${paymentId}`);
};

export const confirmCancellation = (
  contractingKey: string,
  body: IContractingCancellationRequest,
): Promise<AxiosResponse<IContractingCancellationResponse>> => {
  return onlineApi.post(`/contracting/${contractingKey}/cancel`, body);
};

export const requestCancellation = (
  contractingKey: string,
  body: IContractingCancellationRequest,
): Promise<AxiosResponse<IContractingCancellationResponse>> => {
  return onlineApi.post(`/contracting/${contractingKey}/request-cancellation`, body);
};

export const getCancellationStatus = (
  contractingKey: string,
): Promise<AxiosResponse<IContractingCancellationResponse>> => {
  return onlineApi.get(`/contracting/${contractingKey}/cancellation`);
};

export const refuseCancellation = (
  contractingKey: string,
  body: IContractingCancellationRequest,
): Promise<AxiosResponse<IContractingCancellationResponse>> => {
  return onlineApi.post(`/contracting/${contractingKey}/refuse-cancellation`, body);
};

export const cancelVtexOrder = (
  vtexOrderId: string,
  body?: ICancelOrderRequest,
): Promise<AxiosResponse<ICancelVtexOrderResponse>> => {
  return onlineApi.post(`/financing-in-app/cancel-order/${vtexOrderId}`, body);
};

export const getVtexOrder = (vtexOrderId: string): Promise<AxiosResponse<IGetVtexOrderResponse>> => {
  return onlineApi.get(`/financing-in-app/order/${vtexOrderId}`);
};
